import React from 'react'
import PropTypes from 'prop-types'
import { formValues } from 'redux-form'
import CampaignsCard from './campaigns-card'

// Pulse Intelligence (FNB) config section. Future cards (post registry, tiered
// responses and points, missed-post redirect, special moment) mount here too;
// all persist under widget_data.intentBased via redux-form's `change`.
export const PulseIntelligence = ({ change, campaign, ownerId }) => (
  <CampaignsCard
    ownerId={ownerId}
    campaign={campaign}
    onChange={next => change('intentBased.campaign', next)}
  />
)

PulseIntelligence.propTypes = {
  change: PropTypes.func.isRequired,
  campaign: PropTypes.object,
  ownerId: PropTypes.string
}

const ConfigurePulseIntelligence = formValues({
  campaign: 'intentBased.campaign',
  ownerId: 'ownerId'
})(PulseIntelligence)

ConfigurePulseIntelligence.displayName = 'ConfigurePulseIntelligence'

export default ConfigurePulseIntelligence



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-pulse-intelligence/index.js